import { Box, Container, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

export default function Apps() {
  const { t } = useTranslation();

  const handleAppStoreClick = () => {
    window.open('https://apps.apple.com/hk/app/hatsuhiken/id6747922311?l=en-GB', '_blank', 'noopener,noreferrer');
  };

  const handleGooglePlayClick = () => {
    window.open('https://play.google.com/store/apps/details?id=com.hatsuhiken&hl=en', '_blank', 'noopener,noreferrer');
  };

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#fff' }}>

      {/* Main Content */}
      <Container maxWidth="lg" sx={{ py: 4, pt: { xs: 10, md: 4 } }}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '60vh',
            textAlign: 'center',
            gap: 4,
          }}
        >
          {/* Bilingual Title */}
          <Box sx={{ mb: 2 }}>
            <Typography
              sx={{
                fontSize: '24px',
                fontWeight: 700,
                mb: 1,
                lineHeight: 1.2,
              }}
            >
              {t('apps.titleChinese')}
            </Typography>
            <Typography
              sx={{
                fontSize: '24px',
                fontWeight: 700,
                lineHeight: 1.2,
              }}
            >
              {t('apps.titleEnglish')}
            </Typography>
          </Box>

          {/* Download Buttons */}
          <Box
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', md: 'row' },
              gap: 3,
              alignItems: 'center',
              justifyContent: 'center',
              width: '100%',
              maxWidth: 600,
            }}
          >
            {/* App Store Button */}
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
              <Box
                onClick={handleAppStoreClick}
                sx={{
                  cursor: 'pointer',
                  '&:hover': {
                    opacity: 0.8,
                    transform: 'scale(1.02)',
                    transition: 'all 0.2s ease-in-out',
                  },
                }}
              >
                <img
                  src="/icons/apply_store_download.svg"
                  alt="Download on the App Store"
                  style={{ 
                    width: 'auto',
                    height: '60px',
                    maxWidth: '240px'
                  }}
                />
              </Box>
            
            </Box>

            {/* Google Play Button */}
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
              <Box
                onClick={handleGooglePlayClick}
                sx={{
                  cursor: 'pointer',
                  '&:hover': {
                    opacity: 0.8,
                    transform: 'scale(1.02)',
                    transition: 'all 0.2s ease-in-out',
                  },
                }}
              >
                <img
                  src="/icons/play_store_download.svg"
                  alt="GET IT ON Google Play"
                  style={{ 
                    width: 'auto',
                    height: '60px',
                    maxWidth: '240px'
                  }}
                />
              </Box>
            </Box>
          </Box>
        </Box>
      </Container>
    </Box>
  );
}
